import { FunctionalComponent } from 'preact'
import classnames from 'classnames'

import Button from '../../control-components/ui-components/Button'
import { ClassValue } from 'classnames/types'
import { HeroImagePreview } from './HeroImagePreview'

export interface HeroImageProps {
  src: string | null
  dimentionLabel: string
  buttonClassName?: ClassValue
  uploadButtonClassName?: ClassValue
  onEdit: () => void
  onRemove: () => void
  onUpload: () => void
}

export const HeroImage: FunctionalComponent<HeroImageProps> = (props) => {
  const {
    src,
    dimentionLabel,
    onEdit,
    onRemove,
    onUpload,
    buttonClassName,
    uploadButtonClassName
  } = props
  if (src) {
    return (
      <div className='hero-image-container'>
        <HeroImagePreview src={src} dimentionLabel={dimentionLabel} />

        <div className='hero-image_buttons'>
          <Button
            type='button'
            className={classnames(buttonClassName, 'btn--insided-secondary-brand')}
            onClick={onEdit}
          >
            Edit
          </Button>
          <Button
            type='button'
            className={classnames(buttonClassName, 'btn--insided-secondary-brand', 'btn-delete')}
            onClick={onRemove}
          >
            Remove
          </Button>
        </div>
      </div>
    )
  }
  return (
    <div>
      <Button
        type='button'
        className={classnames(uploadButtonClassName, 'btn--insided-secondary-brand')}
        onClick={onUpload}
      >
        Upload image
      </Button>
    </div>
  )
}
